import { render, staticRenderFns } from "./teacherFrom.vue?vue&type=template&id=546f8005&scoped=true&"
import script from "./teacherFrom.vue?vue&type=script&lang=js&"
export * from "./teacherFrom.vue?vue&type=script&lang=js&"
import style0 from "./teacherFrom.vue?vue&type=style&index=0&id=546f8005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f8005",
  null
  
)

export default component.exports